export default __webpack_public_path__ + "static/media/section4-img.3bbb9990.png";